import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Spin } from 'antd';
import { ThemeProvider } from './theme/ThemeProvider';
import FeatherSpinner from './components/FeatherSpinner';
import featherStatic from './assets/saga/feather_spin_static.png';
import { installApiAuthInterceptor } from './utils/installApiAuthInterceptor';
import { analytics } from './firebaseConfig';
import { configureAuthTelemetry } from './utils/authTelemetry';

configureAuthTelemetry(analytics);
installApiAuthInterceptor();

// Preload feather spinner asset early to reduce flicker/fallback window
const __preloadFeather = new Image();
__preloadFeather.src = featherStatic;

const defaultIndicator = <FeatherSpinner style={{ width: 128, height: 128 }} alt="Loading" />;
if ((Spin as any).setDefaultIndicator) {
  (Spin as any).setDefaultIndicator(defaultIndicator);
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
